import { z } from 'zod';

export const MetaInfo = z.object({
  version: z.string(),
  releaseDate: z.string(),
});

export type MetaInfo = z.infer<typeof MetaInfo>;
